import { render, staticRenderFns } from "./withdraw_audit.vue?vue&type=template&id=15b4f418&scoped=true"
import script from "./withdraw_audit.vue?vue&type=script&lang=js"
export * from "./withdraw_audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4f418",
  null
  
)

export default component.exports